<template>
  <v-container fluid class="py-0">
    <v-row>
      <div class="d-flex flex-row" style="width: 100%">
        <div style="width: 360px; border-right: solid 2px #ddd;">
          <div class="d-flex flex-row justify-center ma-4">
            <TextButton
                class="mr-2"
                style="width: 120px"
                :primary="selectedActive"
                :outlined="!selectedActive"
                :disabled="activeCandidates.length === 0"
                @click="onSelectActive"
            >
              選考中
            </TextButton>
            <TextButton
                class="mr-2"
                style="width: 130px"
                :primary="!selectedActive"
                :outlined="selectedActive"
                :disabled="inactiveCandidates.length === 0"
                @click="onSelectInactive"
            >
              見送り/内定承諾
            </TextButton>
          </div>
          <div style="height: calc(100vh - 148px); overflow-y: auto">
            <MessageCandidateList
                :candidates="candidates"
                :value="selectedCandidateId"
                client
                @selectCandidate="onSelectCandidate"
            />
          </div>
        </div>
        <div class="d-flex flex-column" style="width: calc(100% - 360px); height: calc(100vh - 64px)">
          <MessageCandidateOverview
              :candidate="selectedCandidate"
              :company="company"
              :messageId="selectedCandidate.id"
              @change="onChange"
          />
          <div class="px-2" style="height: calc(100vh - 400px); overflow-y: auto" id="message-board">
            <MessageBoard :utterances="utterances"/>
          </div>
          <MessageForm
              :messageId="selectedCandidate.id"
              :candidateUser="selectedCandidate"
              :companyId="company.id"
              @post="onPost"
              @change:status="onChange"
          />
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import MessageCandidateList from "@/components/organisms/MessageCandidateList";
import MessageCandidateOverview from "@/components/organisms/MessageCandidateOverview";
import MessageBoard from "@/components/organisms/MessageBoard";
import TextButton from "@/components/atoms/TextButton";
import MessageForm from "@/components/organisms/MessageForm";
import ApiMixin from "@/ApiMixin";
import ComponentMixin from "@/components/ComponentMixin";

export default {
  mixins: [ApiMixin, ComponentMixin],
  type: "page",
  name: "ClientMessagesPage",
  components: {MessageForm, TextButton, MessageBoard, MessageCandidateOverview, MessageCandidateList},
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("client", ["company"]),
    ...mapGetters("message", ["activeCandidates", "inactiveCandidates", "utterances"]),
    ...mapGetters("jobs", ["job"]),
    selectedCandidate() {
      if (this.candidates) {
        return this.candidates.find(candidate => candidate.id === this.selectedCandidateId) || {
          job: {},
          user: {}
        }
      }
      return {
        job: {},
        user: {}
      };
    },
    candidates() {
      if (this.selectedActive) {
        return this.activeCandidates
      } else {
        return this.inactiveCandidates
      }
    },
    selectedActive() {
      return this.activeCandidates.find(candidate => candidate.id === this.selectedCandidateId) != null
    },
    selectedCandidateId() {
      const id = this.$route.params.id
      if (id) {
        return id
      }
      if (this.activeCandidates.length > 0) {
        return this.activeCandidates[0].id
      }
      return null
    },
  },
  methods: {
    onSelectActive() {
      if (this.activeCandidates.length > 0) {
        const id = this.activeCandidates[0].id
        this.go(`/clients/messages/${id}`)
      } else {
        this.go(`/clients/messages`)
      }
      this.dispatch("message", "clearUtterances")
    },
    onSelectInactive() {
      if (this.inactiveCandidates.length > 0) {
        const id = this.inactiveCandidates[0].id
        this.go(`/clients/messages/${id}`)
      } else {
        this.go(`/clients/messages`)
      }
      this.dispatch("message", "clearUtterances")
    },
    onPost() {
      const board = document.getElementById('message-board');
      const bottom = board.scrollHeight - board.clientHeight;
      board.scroll(0, bottom)
    },
    onSelectCandidate(id) {
      this.go(`/clients/messages/${id}`)
    },
    onChange(params) {
      if (params && params.status === 6) {
        const actives = this.activeCandidates.filter(candidate => candidate.id !== params.messageId)
        if (actives.length > 0) {
          const id = actives[0].id
          this.go(`/clients/messages/${id}`)
        }
      }
      this.loadCompanyMessages(this.company.id)
    }
  },
  watch: {
    "company.id": {
      handler: function (value) {
        if (value) {
          this.loadCompanyMessages(value)
          this.loadMessageTemplates(value)
        }
      },
      immediate: true
    },
    "selectedCandidate": {
      handler: function (value) {
        if (value && value.id) {
          this.loadMessageUtterances(value.id).then(res => {
            res.data.utterances.forEach(utterance => {
              if (utterance.isRead === false) {
                this.updateUtteranceIsRead(this.selectedCandidate.id, utterance.id, 2, true)
              }
            })
          })
        } else {
          this.dispatch("message", "clearUtterances")
        }
      }
    },
    "utterances": {
      handler: function(value) {
        if (value) {
          setTimeout(function() {
            const board = document.getElementById('message-board');
            const bottom = board.scrollHeight - board.clientHeight;
            board.scroll(0, bottom)
          }, 100)
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>
